import ClientsTable from './ClientsTable';

export default ClientsTable;
